// import HomeView from '../views/Landing.vue'
// import NProgress from 'nprogress';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import auth from '@/logic/auth'


const routes: Array<RouteRecordRaw> = [

  {
  path: '/register',
  name: 'register',
  component: () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue')
  },
  {
    path: '/track/:trackingNumber',
    name: 'publicTracking',
    component: () => import(/* webpackChunkName: "public-tracking" */ '../views/PublicTrackingView.vue')
  },
  {
    path: '/staff/register',
    name: 'staffregister',
    component: () => import(/* webpackChunkName: "staffregister" */ '../views/StaffRegisterView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/loginstaff',
    name: 'loginstaff',
    component: () => import(/* webpackChunkName: "loginstaff" */ '../views/LoginStaffView.vue')
  },
  {
    path: '/loading-spinner-examples',
    name: 'loadingspinnerexamples',
    component: () => import(/* webpackChunkName: "loadingspinnerexamples" */ '../components/common/LoadingSpinner.example.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/PrivacyView.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "terms" */ '../views/TermsAndConditions.vue')
  },
  {
    path: '/deleteaccount',
    name: 'deleteaccount',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/DeleteAccountView.vue')
  },
  {
    path: "/activate/:id",
    name: "activateaccount",
    component: () => import(/* webpackChunkName: "activateaccount" */ '../views/ActivateAccountView.vue')
  },
  {
    path: "/extend_booking/:id",
    name: "extendbooking",
    component: () => import(/* webpackChunkName: "extendbooking" */ '../views/ExtendBookingView.vue')
  },
  {
    path: '/partnerpreview',
    name: 'partnerpreview',
    component: () => import(/* webpackChunkName: "partnerpreview" */ '../views/PartnerPreviewView.vue')
  },
  {
    path: '/userpreview',
    name: 'userpreview',
    component: () => import(/* webpackChunkName: "userpreview" */ '../views/UserPreviewView.vue')
  },
  {
    path: '/user/travels',
    name: 'usertravels',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/PetsTravelsView.vue')
  },
  {
    path: '/user/requests',
    name: 'userrequests',
    component: () => import(/* webpackChunkName: "userrequests" */ '../views/UserRequestsView.vue')
  },
  {
    path: '/user/request/:id',
    name: 'userrequest',
    component: () => import(/* webpackChunkName: "offers" */ '../views/Offers.vue')
  },
  {
    path: '/offers',
    name: 'offers',
    component: () => import(/* webpackChunkName: "offers" */ '../views/Offers.vue')
  },
  {
    path: '/user/travel/:id',
    name: 'usertravel',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/UserTravelView.vue')
  },
  {
    path: '/user/charges',
    name: 'usercharges',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/UserChargesView.vue')
  },
  {
    path: '/partner/payments',
    name: 'partnerpayments',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/PartnerPaymentsView.vue')
  },
  {
    path: '/partner/payments/:paymentId',
    name: 'partner-payment-detail',
    component: () => import(/* webpackChunkName: "partner-payment-detail" */ '../components/Dashboard_Partner/PartnerPaymentDetail.vue')
  },
  {
    path: '/partner/charges/:chargeId',
    name: 'partner-charge-detail',
    component: () => import(/* webpackChunkName: "partner-charge-detail" */ '../views/PartnerChargeDetailView.vue')
  },
  {
    path: '/reset_request',
    name: 'reset_request',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/ResetView.vue')
  },
  {
    path: '/howto',
    name: 'howto',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/HowToView.vue')
  },
  {
    path: '/partner/availability',
    name: 'partneravailability',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/PartnerAvailabilityView.vue')
  },
  {
    path: '/reset_password/:id',
    name: 'reset_password',
    component: () => import(/* webpackChunkName: "usertravels" */ '../views/ResetPasswordView.vue')
  },
  {
    path: '/travelselection',
    name: 'travelselection',
    component: () => import(/* webpackChunkName: "travelselection" */ '../views/TravelSelectionView.vue')
  },
  {
    path: "/",
    name: "home",
    props: true,
    component: () => import(/* webpackChunkName: "travelselection" */ '../views/Landing.vue')
  },
  {
    path: "/request-shipment",
    name: "requestShipment",
    component: () => import(/* webpackChunkName: "request-shipment" */ '../views/RequestShipmentFlow.vue')
  },
  {
    path: "/my-shipments",
    name: "myShipments",
    component: () => import(/* webpackChunkName: "my-shipments" */ '../views/MyShipmentsView.vue')
  },
  {
    path: "/my-shipments/:id",
    name: "shipmentDetail",
    component: () => import(/* webpackChunkName: "shipment-detail" */ '../views/ShipmentDetailView.vue')
  },
  {
    path: "/travelbooking",
    name: "travelbooking",
    component: () => import(/* webpackChunkName: "travelbooking" */ '../views/TravelBookingView.vue')
  },
  {
    path: "/paymentsuccess/:payment_id",
    name: "paymentsuccess",
    component: () => import(/* webpackChunkName: "paymentsuccess" */ '../views/PaymentSuccessView.vue')
  },
  {
    path: "/user/info",
    name: "userinfo",
    component: () => import(/* webpackChunkName: "user_info" */ '../views/UserInfoView.vue')
  },
  {
    path: "/user/passanger/:id",
    name: "user_passanger",
    component: () => import(/* webpackChunkName: "user_passanger" */ '../views/UserPassangerView.vue')
  },
  {
    path: '/user/travel_chat/:id',
    name: 'userPassangerChat',
    component: () => import(/* webpackChunkName: "userChat" */ '../views/UserPassangerChatView.vue')
  },
  {
    path: "/user",
    name: "useraccount",
    component: () => import(/* webpackChunkName: "useraccount" */ '../views/UserAccount.vue')
  },
  {
    path: "/checkin/:passanger_id",
    name: "checkin",
    component: () => import(/* webpackChunkName: "checkin" */ '../views/CheckInView.vue')
  },
  {
    path: "/travel_progress",
    name: "travel_progress",
    component: () => import(/* webpackChunkName: "travel_progress" */ '../views/TravelInProgressView.vue')
  },
  {
    path: "/pets",
    name: "pets",
    component: () => import(/* webpackChunkName: "checkin" */ '../views/PetsView.vue')
  },
  {
    path: "/newpet",
    name: "new_pet",
    component: () => import(/* webpackChunkName: "checkin" */ '../views/New_petView.vue')
  },
  {
    path: "/offer/payment/:offer_id",
    name: "offerPayment",
    component: () => import(/* webpackChunkName: "paymentsuccess" */ '../views/OfferPaymentView.vue')
  },
  {
    path: "/paymentsuccess/:payment_id",
    name: "paymentsuccess",
    component: () => import(/* webpackChunkName: "paymentsuccess" */ '../views/PaymentSuccessView.vue')
  },
  {
    path: "/user/passanger/evaluation/:id",
    name: "evaluation",
    component: () => import(/* webpackChunkName: "evaluation" */ '../views/EvaluationView.vue')
  },
  {
    path: '/travel/options/:offer_id',
    name: 'travel_options',
    component: () => import(/* webpackChunkName: "travel_options" */ '../views/TravelOptionsView.vue')
  },


 
/*---------------------------------------------------------------------------------------------------------------------------------*/

//Rutas de Partners

/*---------------------------------------------------------------------------------------------------------------------------------*/
  {
    path: '/cochepartner',
    name: 'cochepartner',
    component: () => import(/* webpackChunkName: "cochepartner" */ '../views/Dashboard_PartnerView/CochePartnerView.vue')
  },
  {
    path: '/estadisticaspartner',
    name: 'estadisticaspartner',
    component: () => import(/* webpackChunkName: "estadistcaspartner" */ '../views/Dashboard_PartnerView/EstadisticasPartnerView.vue')
  },
  {
    path: '/facturacionpartner',
    name: 'facturacionpartner',
    component: () => import(/* webpackChunkName: "facturacionpartner" */ '../views/Dashboard_PartnerView/FacturacionPartnerView.vue')
  },
  {
    path: '/newtravel',
    name: 'newtravel',
    component: () => import(/* webpackChunkName: "newtravel" */ '../views/Dashboard_PartnerView/NewTravelView.vue')
  },

  {
    path: '/partner/request/:id',
    name: 'requestDetail',
    component: () => import(/* webpackChunkName: "requestDetail" */ '../views/Dashboard_PartnerView/RequestDetailView.vue')
  },
  {
    path: '/partner/travel/:id',
    name: 'partnertravel',
    component: () => import(/* webpackChunkName: "partnertravel" */ '../views/Dashboard_PartnerView/PartnerTravelView.vue')
  },
  {
    path: '/partner/travel/evaluation/:id',
    name: 'partner_evaluation',
    component: () => import(/* webpackChunkName: "partner_evaluation" */ '../views/Dashboard_PartnerView/PartnerEvaluationView.vue')
  },
  {
    path: '/partner/travel_chat/:id',
    name: 'partnerChat',
    component: () => import(/* webpackChunkName: "partnerChat" */ '../views/Dashboard_PartnerView/PartnerChatView.vue')
  },
  {
    path: '/staff',
    name: 'staffHome',
    component: () => import(/* webpackChunkName: "staffhome" */ '../views/StaffHomeView.vue')
  },
  {
    path: '/staff/services',
    name: 'staffServices',
    component: () => import(/* webpackChunkName: "staffservices" */ '../views/StaffServicesView.vue')
  },

  {
    path: '/staff/services/:id',
    name: 'service-detail',
    component: () => import(/* webpackChunkName: "service-detail" */ '../views/ServiceDetailView.vue')
  },
  {
    path: '/staff/car-documents',
    name: 'staff-car-documents',
    component: () => import(/* webpackChunkName: "staff-car-documents" */ '../views/StaffCarDocumentsView.vue')
  },
  {
    path: '/staff/car-documents/:id',
    name: 'staff-car-document-detail',
    component: () => import(/* webpackChunkName: "staff-car-document-detail" */ '../views/StaffCarDocumentDetailView.vue')
  },
  {
    path: '/staff/incidents',
    name: 'staff-incidents',
    component: () => import(/* webpackChunkName: "staff-incidents" */ '../views/StaffIncidentsView.vue')
  },
  {
    path: '/staff/incidents/:id',
    name: 'staff-incident-detail',
    component: () => import(/* webpackChunkName: "staff-incident-detail" */ '../views/StaffIncidentDetailView.vue')
  },
  {
    path: '/staff/operations',
    name: 'staff-operations',
    component: () => import(/* webpackChunkName: "staff-operations" */ '../views/StaffOperationsView.vue')
  },
  {
    path: '/staff/promotions',
    name: 'staff-promotions',
    component: () => import(/* webpackChunkName: "staff-promotions" */ '../views/StaffPromotionsView.vue')
  },
  {
    path: '/staff/partner-payments',
    name: 'staff-partner-payments-dashboard',
    component: () => import(/* webpackChunkName: "staff-partner-payments-dashboard" */ '../components/Staff/StaffPartnerPaymentsDashboard.vue')
  },
  {
    path: '/staff/partner-payments/:partnerId',
    name: 'staff-partner-payments',
    component: () => import(/* webpackChunkName: "staff-partner-payments" */ '../views/StaffPartnerPaymentsView.vue')
  },
  {
    path: '/staff/partner-payments/payment/:paymentId',
    name: 'staff-partner-payment-detail',
    component: () => import(/* webpackChunkName: "staff-partner-payment-detail" */ '../components/Staff/StaffPartnerPaymentDetail.vue')
  },
  {
    path: '/staff/fleet',
    name: 'staffFleet',
    component: () => import(/* webpackChunkName: "staff-fleet" */ '../views/Staff/FleetDashboardView.vue')
  },
  {
    path: '/staff/vehicles',
    name: 'staffVehicles',
    component: () => import(/* webpackChunkName: "staff-vehicles" */ '../views/Staff/StaffVehiclesView.vue')
  },
  {
    path: '/staff/partners',
    name: 'staffPartners',
    component: () => import(/* webpackChunkName: "staff-partners" */ '../views/Staff/StaffPartnersView.vue')
  },
  {
    path: '/staff/partners/:partnerId/vehicles',
    name: 'staffPartnerVehicles',
    component: () => import(/* webpackChunkName: "staff-partner-vehicles" */ '../views/Staff/StaffPartnerVehiclesView.vue')
  },
  {
    path: '/staff/users',
    name: 'staffUsers',
    component: () => import(/* webpackChunkName: "staff-users" */ '../views/Staff/StaffUsersView.vue')
  },
  {
    path: '/staff/shipments',
    name: 'staffShipments',
    component: () => import(/* webpackChunkName: "staff-shipments" */ '../views/Staff/StaffShipmentsView.vue')
  },
  {
    path: '/staff/shipments/bulk-upload',
    name: 'staffBulkUpload',
    component: () => import(/* webpackChunkName: "staff-bulk-upload" */ '../views/Staff/StaffBulkUploadView.vue')
  },
  {
    path: '/staff/shipments/:id',
    name: 'staffShipmentDetail',
    component: () => import(/* webpackChunkName: "staff-shipment-detail" */ '../views/Staff/StaffShipmentDetailView.vue')
  },
  {
    path: '/staff/consolidation',
    name: 'staffConsolidation',
    component: () => import(/* webpackChunkName: "staff-consolidation" */ '../views/Staff/StaffConsolidationView.vue')
  },
  {
    path: '/staff/consolidation/vehicle',
    name: 'staffConsolidationVehicle',
    component: () => import(/* webpackChunkName: "staff-consolidation-vehicle" */ '../views/Staff/StaffConsolidationVehicleView.vue')
  },
  {
    path: '/staff/deliveries',
    name: 'staffDeliveries',
    component: () => import(/* webpackChunkName: "staff-deliveries" */ '../views/Staff/StaffDeliveriesView.vue')
  },
  {
    path: '/staff/deliveries/:id',
    name: 'staffDeliveryDetail',
    component: () => import(/* webpackChunkName: "staff-delivery-detail" */ '../views/Staff/StaffDeliveryDetailView.vue')
  },
  {
    path: '/staff/deliveries/:id/plan-route',
    name: 'staffRoutePlanning',
    component: () => import(/* webpackChunkName: "staff-route-planning" */ '../views/Staff/StaffRoutePlanningView.vue'),
    meta: { requiresAuth: true, roles: ['staff'] }
  },
  {
    path: '/staff/fleet/vehicles/new',
    name: 'staffNewVehicle',
    component: () => import(/* webpackChunkName: "staff-new-vehicle" */ '../views/Staff/NewVehicleView.vue')
  },
  {
    path: '/staff/fleet/vehicles/:id',
    name: 'staffVehicleDetail',
    component: () => import(/* webpackChunkName: "staff-vehicle-detail" */ '../views/Staff/VehicleDetailView.vue')
  },
  // {
  //   path: '/staff/fleet/assignments',
  //   name: 'staffAssignments',
  //   component: () => import(/* webpackChunkName: "staff-assignments" */ '../views/Staff/AssignmentsView.vue')
  // },
  {
    path: '/partner/vehicles',
    name: 'partnerVehicles',
    component: () => import(/* webpackChunkName: "partner-vehicles" */ '../views/Partner/PartnerVehiclesView.vue')
  },
  {
    path: '/partner/travel/:id/incidents',
    name: 'partner-travel-incidents',
    component: () => import(/* webpackChunkName: "partner-travel-incidents" */ '../views/PartnerIncidentsView.vue')
  },
  {
    path: '/partner',
    name: "partneraccount",
    component: () => import(/* webpackChunkName: "partneraccount" */ '../views/Dashboard_PartnerView/PartnerAccount.vue')
  },
  {
    path: "/partner/info",
    name: "partnerinfo",
    component: () => import(/* webpackChunkName: "partner_info" */ '../views/Dashboard_PartnerView/PartnerInfoView.vue')
  },
  {
    path: "/partner/travels",
    name: "partnertravels",
    component: () => import(/* webpackChunkName: "partnertravels" */ '../views/Dashboard_PartnerView/PartnerTravelsView.vue')
  },
  {
    path: "/partner/requests",
    name: "partnerRequests",
    component: () => import(/* webpackChunkName: "partner-requests" */ '../views/Partner/PartnerRequestsView.vue'),
    meta: { requiresAuth: true, roles: ['partner'] }
  },
  {
    path: "/partner/deliveries/:deliveryId",
    name: "partnerDeliveryDetail",
    component: () => import(/* webpackChunkName: "partner-delivery-detail" */ '../views/Partner/PartnerDeliveryDetailView.vue'),
    meta: { requiresAuth: true, roles: ['partner'] }
  },
  {
    path: "/partner/repartos",
    name: "partnerDeliveries",
    component: () => import(/* webpackChunkName: "partner-deliveries" */ '../views/Partner/PartnerDeliveriesView.vue'),
    meta: { requiresAuth: true, roles: ['partner'] }
  },
  {
    path: "/partner/trips",
    name: "partnertrips",
    component: () => import(/* webpackChunkName: "partnertrips" */ '../views/Dashboard_PartnerView/TripsView.vue')
  },
  {
    path: "/partner/cars",
    name: "partner_cars",
    component: () => import(/* webpackChunkName: "partner_cars" */ '../views/Dashboard_PartnerView/PartnerCarsView.vue')
  },
  {
    path: "/new_car",
    name: "new_car",
    component: () => import(/* webpackChunkName: "newcar" */ '../views/NewCarView.vue')
  },
  {
    path: "/car/:id",
    name: "car",
    component: () => import(/* webpackChunkName: "car" */ '../views/CarView.vue')
  },
  {
    path: "/pet/:id",
    name: "pet",
    component: () => import(/* webpackChunkName: "car" */ '../views/PetView.vue')
  },
  {
    path: "/car/:id/documents",
    name: "car_docs",
    component: () => import(/* webpackChunkName: "car" */ '../components/Owner/CarDocuments.vue')
  },
  {
    path: "/car/:id/travels",
    name: "car_travels",
    component: () => import(/* webpackChunkName: "car" */ '../components/Owner/CarTravels.vue')
  },
  {
    path: "/car/:id/partners",
    name: "car_partners",
    component: () => import(/* webpackChunkName: "car" */ '../components/Owner/CarPartners.vue')
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import(/* webpackChunkName: "car" */ '../views/SettingsView.vue')
  },
  {
    path: "/available_partners",
    name: "available_partners",
    component: () => import(/* webpackChunkName: "available_partners" */ '../views/AvailablePartnersView.vue')
  },
  {
    path: '/partner/availability/form',
    name: 'partneravailabilityform',
    component: () => import(/* webpackChunkName: "partneravailabilityform" */ '../views/PartnerAvailabilityFormView.vue')
  },
  {
    path: '/request_details/:request_id',
    name: 'request_details',
    component: () => import(/* webpackChunkName: "request_details" */ '../views/RequestDetails.vue')
  },
  {
    path: '/partner-home', // New route for Partner Landing
    name: 'partnerhome',
    component: () => import(/* webpackChunkName: "partnerlanding" */ '../views/PartnerLandingView.vue')
  },


/*---------------------------------------------------------------------------------------------------------------------------------*/

  //Rutas de Empresa

/*---------------------------------------------------------------------------------------------------------------------------------*/
  {
    path: '/facturacionempresa',
    name: 'facturacionempresa',
    component: () => import(/* webpackChunkName: "partner" */ '../views/Dashboard_EmpresaView/FacturacionEmpresaView.vue')
  },
  {
    path: '/pagosempresa',
    name: 'pagosempresa',
    component: () => import(/* webpackChunkName: "partner" */ '../views/Dashboard_EmpresaView/PagosEmpresaView.vue')
  },
  {
    path: '/perfilesempresa',
    name: 'perfilesempresa',
    component: () => import(/* webpackChunkName: "partner" */ '../views/Dashboard_EmpresaView/PerfilesEmpresaView.vue')
  },
  {
    path: '/viajesempresa',
    name: 'viajesempresa',
    component: () => import(/* webpackChunkName: "partner" */ '../views/Dashboard_EmpresaView/ViajesEmpresaView.vue')
  },
  {
    path: '/empresa',
    name: 'empresa',
    component: () => import(/* webpackChunkName: "partner" */ '../views/Dashboard_EmpresaView/EmpresaView.vue')
  },
/*---------------------------------------------------------------------------------------------------------------------------------*/
  {
    path: '/viajesrealizados',
    name: 'viajesrealizados',  
    component: () => import(/* webpackChunkName: "partner" */ '../views/Dashboard_EmpresaView/EmpresaView.vue')
  },





  //Rutas de Usuarios
/*------------------------------------------------------------------------------------------------------------------------------
/*---------------------------------------------------------------------------------------------------------------------------------*/





  ,
  // ============================================================
  // AYVENS ROUTES - Renting de Vehículos
  // ============================================================
  
  // AYVENS Routes
  {
    path: '/ayvens',
    name: 'ayvens-home',
    component: () => import(/* webpackChunkName: "ayvens-home" */ '../views/Ayvens/AyvensHomeView.vue')
  },
  // USER Routes
  {
    path: '/ayvens/contracts',
    name: 'ayvens-contracts',
    component: () => import(/* webpackChunkName: "ayvens-contracts" */ '../views/Ayvens/UserContractsView.vue')
  },
  {
    path: '/ayvens/contracts/new',
    name: 'ayvens-contract-create',
    component: () => import(/* webpackChunkName: "ayvens-contract-create" */ '../views/Ayvens/UserContractCreateView.vue')
  },
  {
    path: '/ayvens/contract/:id',
    name: 'ayvens-contract-detail',
    component: () => import(/* webpackChunkName: "ayvens-contract-detail" */ '../views/Ayvens/ContractDetailView.vue')
  },
  {
    path: '/ayvens/contract/:id/drivers',
    name: 'ayvens-contract-drivers',
    component: () => import(/* webpackChunkName: "ayvens-contract-drivers" */ '../views/Ayvens/UserAdditionalDriversView.vue')
  },
  {
    path: '/ayvens/contract/:id/vehicle',
    name: 'ayvens-vehicle-detail',
    component: () => import(/* webpackChunkName: "ayvens-vehicle-detail" */ '../views/Ayvens/VehicleDetailView.vue')
  },
  {
    path: '/ayvens/contract/:id/maintenance',
    name: 'ayvens-maintenance-request',
    component: () => import(/* webpackChunkName: "ayvens-maintenance-request" */ '../views/Ayvens/UserMaintenanceRequestView.vue')
  },
  {
    path: '/ayvens/maintenance',
    name: 'ayvens-maintenance-requests',
    component: () => import(/* webpackChunkName: "ayvens-maintenance-requests" */ '../views/Ayvens/UserMaintenanceRequestsView.vue')
  },
  {
    path: '/ayvens/incidents',
    name: 'ayvens-incidents',
    component: () => import(/* webpackChunkName: "ayvens-incidents" */ '../views/Ayvens/UserIncidentsView.vue')
  },
  {
    path: '/ayvens/incidents/report',
    name: 'ayvens-report-incident',
    component: () => import(/* webpackChunkName: "ayvens-report-incident" */ '../views/Ayvens/ReportIncidentView.vue')
  },
  {
    path: '/ayvens/incident/:id',
    name: 'ayvens-incident-detail',
    component: () => import(/* webpackChunkName: "ayvens-incident-detail" */ '../views/Ayvens/IncidentDetailView.vue')
  },
  {
    path: '/ayvens/fines',
    name: 'ayvens-fines',
    component: () => import(/* webpackChunkName: "ayvens-fines" */ '../views/Ayvens/UserFinesView.vue')
  },
  {
    path: '/ayvens/fine/:id',
    name: 'ayvens-fine-detail',
    component: () => import(/* webpackChunkName: "ayvens-fine-detail" */ '../views/Ayvens/UserFineDetailView.vue')
  },
  
  // STAFF Routes
  {
    path: '/staff/ayvens',
    name: 'staff-ayvens-dashboard',
    component: () => import(/* webpackChunkName: "staff-ayvens-dashboard" */ '../views/Staff/StaffAyvensDashboardView.vue')
  },
  {
    path: '/staff/ayvens/contracts',
    name: 'staff-ayvens-contracts',
    component: () => import(/* webpackChunkName: "staff-ayvens-contracts" */ '../views/Staff/StaffAyvensContractsView.vue')
  },
  {
    path: '/staff/ayvens/contracts/new',
    name: 'staff-ayvens-contract-create',
    component: () => import(/* webpackChunkName: "staff-ayvens-contract-create" */ '../views/Staff/StaffAyvensContractCreateView.vue')
  },
  {
    path: '/staff/ayvens/contract/:id',
    name: 'staff-ayvens-contract-detail',
    component: () => import(/* webpackChunkName: "staff-ayvens-contract-detail" */ '../views/Staff/StaffAyvensContractDetailView.vue')
  },
  {
    path: '/staff/ayvens/incidents',
    name: 'staff-ayvens-incidents',
    component: () => import(/* webpackChunkName: "staff-ayvens-incidents" */ '../views/Staff/StaffIncidentsView.vue')
  },
  {
    path: '/staff/ayvens/incident/:id',
    name: 'staff-ayvens-incident-detail',
    component: () => import(/* webpackChunkName: "staff-ayvens-incident-detail" */ '../views/Staff/StaffIncidentDetailView.vue')
  },
  {
    path: '/staff/ayvens/fines',
    name: 'staff-ayvens-fines',
    component: () => import(/* webpackChunkName: "staff-ayvens-fines" */ '../views/Staff/StaffFinesView.vue')
  },
  {
    path: '/staff/ayvens/fine/:id',
    name: 'staff-ayvens-fine-detail',
    component: () => import(/* webpackChunkName: "staff-ayvens-fine-detail" */ '../views/Staff/StaffFineDetailView.vue')
  },
  // STAFF Routes - Ayvens Return Process
  {
    path: '/staff/ayvens/return-processes',
    name: 'staff-ayvens-return-processes',
    component: () => import(/* webpackChunkName: "staff-ayvens-return-processes" */ '../views/Staff/StaffReturnProcessListView.vue')
  },
  {
    path: '/staff/ayvens/return-process/:id',
    name: 'staff-ayvens-return-process-detail',
    component: () => import(/* webpackChunkName: "staff-ayvens-return-process-detail" */ '../views/Staff/StaffReturnProcessDetailView.vue')
  },
  // USER Routes - Ayvens Return Process
  {
    path: '/ayvens/return-process',
    name: 'ayvens-return-process',
    component: () => import(/* webpackChunkName: "ayvens-return-process" */ '../views/Ayvens/UserReturnProcessView.vue')
  },
  
  // USER Routes - Ayvens Documents
  {
    path: '/ayvens/contract/:id/documents',
    name: 'ayvens-contract-documents',
    redirect: to => ({
      name: 'ayvens-contract-detail',
      params: { id: to.params.id },
      query: { tab: 'documents' }
    })
  },

  // STAFF Routes - Ayvens Documents
  {
    path: '/staff/ayvens/documents',
    name: 'staff-ayvens-documents',
    component: () => import(/* webpackChunkName: "staff-ayvens-documents" */ '../views/Staff/StaffDocumentsView.vue')
  },
  {
    path: '/staff/ayvens/maintenance',
    name: 'staff-ayvens-maintenance',
    component: () => import(/* webpackChunkName: "staff-ayvens-maintenance" */ '../views/Staff/StaffAyvensMaintenanceView.vue')
  },
  {
    path: '/staff/ayvens/service-partners',
    name: 'staff-ayvens-service-partners',
    component: () => import(/* webpackChunkName: "staff-ayvens-service-partners" */ '../views/Staff/StaffAyvensServicePartnersView.vue')
  },

  // STAFF Routes - Ayvens Metrics
  {
    path: '/staff/ayvens/metrics',
    name: 'staff-ayvens-metrics',
    component: () => import(/* webpackChunkName: "staff-ayvens-metrics" */ '../views/Staff/StaffMetricsDashboardView.vue')
  },

  // USER Routes - Ayvens NPS
  {
    path: '/ayvens/nps/survey',
    name: 'ayvens-nps-survey',
    component: () => import(/* webpackChunkName: "ayvens-nps-survey" */ '../views/Ayvens/UserNPSSurveyView.vue')
  },
  {
    path: '/ayvens/nps/history',
    name: 'ayvens-nps-history',
    component: () => import(/* webpackChunkName: "ayvens-nps-history" */ '../views/Ayvens/UserNPSHistoryView.vue')
  }
  ,
  {
    path: '/ayvens/benefits',
    name: 'ayvens-benefits',
    component: () => import(/* webpackChunkName: "ayvens-benefits" */ '../views/Ayvens/BenefitsPartnersMapView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    const isLogged = await auth.getUserLogged()
    if (!isLogged) {
      return next('/login')
    }

    const personType = await auth.getPersonType()
    if (personType === 'Staff') {
      return next('/staff/ayvens')
    }
    if (personType === 'User') {
      return next('/ayvens')
    }

    return next('/login')
  }

  return next()
})

// router.beforeResolve((to, from, next) => {
//   // If this isn't an initial page load.
//   if (to.name) {
//     // Start the route progress bar.
//     NProgress.start()
//   }
//   next()
// })

// router.afterEach(() => {
//   // Complete the animation of the route progress bar.
//   NProgress.done()
// })

export default router
